module.exports = __webpack_public_path__ + "img/tutup.85a63530.png";